<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="12"
  viewBox="0 0 16 12"
  fill="none"
  aria-hidden="true"
>
  <g clip-path="url(#clip_store_us_flag)">
    <path
      d="M0.878261 0H15.1188C15.6029 0 15.9971 0.425 15.9971 0.946875V11.05C15.9971 11.5719 15.6029 11.9969 15.1188 11.9969H0.878261C0.394203 12 0 11.575 0 11.0531V0.946875C0 0.425 0.394203 0 0.878261 0Z"
      fill="#B22234"
    />
    <path
      d="M0.0057971 0.853027H15.9971C16 0.884277 16.0029 0.915527 16.0029 0.949902V1.86865H0V0.946777C0 0.915527 0.00289855 0.884277 0.0057971 0.853027ZM16 2.70928V3.72178H0V2.70928H16ZM16 4.56553V5.57803H0V4.56553H16ZM16 6.42178V7.43428H0V6.42178H16ZM16 8.27803V9.29053H0V8.27803H16ZM16 10.1343V11.0499C16 11.0812 15.9971 11.1155 15.9942 11.1468H0.0057971C0.00289855 11.1187 0 11.0843 0 11.053V10.1374H16V10.1343Z"
      fill="white"
    />
    <path
      d="M6.02899 0V6.4625H0V0.946875C0 0.425 0.394203 0 0.878261 0H6.02899Z"
      fill="#3C3B6E"
    />
    <path
      d="M0.356833 0.893799L0.556833 1.56567L0.0292969 1.15005H0.684369L0.153935 1.56567L0.356833 0.893799Z"
      fill="white"
    />
    <path
      d="M0.356833 2.19385L0.556833 2.86572L0.0292969 2.4501H0.684369L0.153935 2.86572L0.356833 2.19385Z"
      fill="white"
    />
    <path
      d="M0.356833 3.49365L0.556833 4.16553L0.0292969 3.7499H0.684369L0.153935 4.16553L0.356833 3.49365Z"
      fill="white"
    />
    <path
      d="M0.356833 4.7937L0.556833 5.46558L0.0292969 5.04995H0.684369L0.153935 5.46558L0.356833 4.7937Z"
      fill="white"
    />
    <path
      d="M1.06386 0.243652L1.26676 0.915527L0.736328 0.499902H1.3943L0.860966 0.915527L1.06386 0.243652Z"
      fill="white"
    />
    <path
      d="M1.06386 1.5437L1.26676 2.21558L0.736328 1.79995H1.3943L0.860966 2.21558L1.06386 1.5437Z"
      fill="white"
    />
    <path
      d="M1.06386 2.84375L1.26676 3.51562L0.736328 3.1H1.3943L0.860966 3.51562L1.06386 2.84375Z"
      fill="white"
    />
    <path
      d="M1.06386 4.1438L1.26676 4.81567L0.736328 4.40005H1.3943L0.860966 4.81567L1.06386 4.1438Z"
      fill="white"
    />
    <path
      d="M1.06386 5.44385L1.26676 6.11572L0.736328 5.7001H1.3943L0.860966 6.11572L1.06386 5.44385Z"
      fill="white"
    />
    <path
      d="M1.7748 0.893799L1.9777 1.56567L1.44727 1.15005H2.10234L1.5719 1.56567L1.7748 0.893799Z"
      fill="white"
    />
    <path
      d="M1.7748 2.19385L1.9777 2.86572L1.44727 2.4501H2.10234L1.5719 2.86572L1.7748 2.19385Z"
      fill="white"
    />
    <path
      d="M1.7748 3.49365L1.9777 4.16553L1.44727 3.7499H2.10234L1.5719 4.16553L1.7748 3.49365Z"
      fill="white"
    />
    <path
      d="M1.7748 4.7937L1.9777 5.46558L1.44727 5.04995H2.10234L1.5719 5.46558L1.7748 4.7937Z"
      fill="white"
    />
    <path
      d="M2.48379 0.243652L2.68379 0.915527L2.15625 0.499902H2.81132L2.28089 0.915527L2.48379 0.243652Z"
      fill="white"
    />
    <path
      d="M2.48379 1.5437L2.68379 2.21558L2.15625 1.79995H2.81132L2.28089 2.21558L2.48379 1.5437Z"
      fill="white"
    />
    <path
      d="M2.48379 2.84375L2.68379 3.51562L2.15625 3.1H2.81132L2.28089 3.51562L2.48379 2.84375Z"
      fill="white"
    />
    <path
      d="M2.48379 4.1438L2.68379 4.81567L2.15625 4.40005H2.81132L2.28089 4.81567L2.48379 4.1438Z"
      fill="white"
    />
    <path
      d="M2.48379 5.44385L2.68379 6.11572L2.15625 5.7001H2.81132L2.28089 6.11572L2.48379 5.44385Z"
      fill="white"
    />
    <path
      d="M3.19082 0.893799L3.39372 1.56567L2.86328 1.15005H3.51835L2.98792 1.56567L3.19082 0.893799Z"
      fill="white"
    />
    <path
      d="M3.19082 2.19385L3.39372 2.86572L2.86328 2.4501H3.51835L2.98792 2.86572L3.19082 2.19385Z"
      fill="white"
    />
    <path
      d="M3.19082 3.49365L3.39372 4.16553L2.86328 3.7499H3.51835L2.98792 4.16553L3.19082 3.49365Z"
      fill="white"
    />
    <path
      d="M3.19082 4.7937L3.39372 5.46558L2.86328 5.04995H3.51835L2.98792 5.46558L3.19082 4.7937Z"
      fill="white"
    />
    <path
      d="M3.90176 0.243652L4.10465 0.915527L3.57422 0.499902H4.22929L3.69886 0.915527L3.90176 0.243652Z"
      fill="white"
    />
    <path
      d="M3.90176 1.5437L4.10465 2.21558L3.57422 1.79995H4.22929L3.69886 2.21558L3.90176 1.5437Z"
      fill="white"
    />
    <path
      d="M3.90176 2.84375L4.10465 3.51562L3.57422 3.1H4.22929L3.69886 3.51562L3.90176 2.84375Z"
      fill="white"
    />
    <path
      d="M3.90176 4.1438L4.10465 4.81567L3.57422 4.40005H4.22929L3.69886 4.81567L3.90176 4.1438Z"
      fill="white"
    />
    <path
      d="M3.90176 5.44385L4.10465 6.11572L3.57422 5.7001H4.22929L3.69886 6.11572L3.90176 5.44385Z"
      fill="white"
    />
    <path
      d="M4.60879 0.893799L4.81168 1.56567L4.28125 1.15005H4.93632L4.40879 1.56567L4.60879 0.893799Z"
      fill="white"
    />
    <path
      d="M4.60879 2.19385L4.81168 2.86572L4.28125 2.4501H4.93632L4.40879 2.86572L4.60879 2.19385Z"
      fill="white"
    />
    <path
      d="M4.60879 3.49365L4.81168 4.16553L4.28125 3.7499H4.93632L4.40879 4.16553L4.60879 3.49365Z"
      fill="white"
    />
    <path
      d="M4.60879 4.7937L4.81168 5.46558L4.28125 5.04995H4.93632L4.40879 5.46558L4.60879 4.7937Z"
      fill="white"
    />
    <path
      d="M5.31972 0.243652L5.52262 0.915527L4.99219 0.499902H5.64726L5.11683 0.915527L5.31972 0.243652Z"
      fill="white"
    />
    <path
      d="M5.31972 1.5437L5.52262 2.21558L4.99219 1.79995H5.64726L5.11683 2.21558L5.31972 1.5437Z"
      fill="white"
    />
    <path
      d="M5.31972 2.84375L5.52262 3.51562L4.99219 3.1H5.64726L5.11683 3.51562L5.31972 2.84375Z"
      fill="white"
    />
    <path
      d="M5.31972 4.1438L5.52262 4.81567L4.99219 4.40005H5.64726L5.11683 4.81567L5.31972 4.1438Z"
      fill="white"
    />
    <path
      d="M5.31972 5.44385L5.52262 6.11572L4.99219 5.7001H5.64726L5.11683 6.11572L5.31972 5.44385Z"
      fill="white"
    />
  </g>
  <defs>
    <clipPath id="clip_store_us_flag">
      <rect width="16" height="12" fill="white" />
    </clipPath>
  </defs>
</svg>